import React from "react";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt } from "react-icons/fa";
import { resolvePublicFileUrl } from "../../constants/api-urls";
import {
  buildInfraListingSpecItems,
  getInfraListingDetailHref,
  getInfraListingImagePath,
  getInfraListingLocation,
  getInfraListingPriceLabel,
  getInfraListingShareImage,
  getInfraTransactionLabel,
  resolveInfraListingRibbon,
} from "../../utils/infrastructureListingCardHelpers";
import MarketplaceProductShareButton from "./MarketplaceProductShareButton";

export default function InfrastructureListingGridCard({ item, detailTab = "real-estate" }) {
  const detailHref = getInfraListingDetailHref(item, detailTab);
  const imagePath = getInfraListingImagePath(item);
  const location = getInfraListingLocation(item);
  const priceLabel = getInfraListingPriceLabel(item);
  const specItems = buildInfraListingSpecItems(item);
  const ribbon = resolveInfraListingRibbon(item);
  const transactionLabel = getInfraTransactionLabel(item.transactionType);

  return (
    <article className="marketplace-product-grid-card marketplace-product-grid-card--infra">
      <div className="marketplace-product-grid-card__media">
        {ribbon ? (
          <span className={`marketplace-product-grid-card__ribbon ${ribbon.className}`}>{ribbon.label}</span>
        ) : null}
        <Link to={detailHref} className="marketplace-product-grid-card__media-link">
          {imagePath ? (
            <img src={resolvePublicFileUrl(imagePath)} alt={item.title} loading="lazy" />
          ) : (
            <div className="marketplace-product-grid-card__no-image">No image</div>
          )}
        </Link>
      </div>

      <div className="marketplace-product-grid-card__body">
        <Link to={detailHref} className="marketplace-product-grid-card__title">
          {item.title}
        </Link>

        <div className="marketplace-product-grid-card__meta">
          {item.categoryLabel && item.categoryLabel !== "—" ? (
            <span className="marketplace-product-grid-card__company">{item.categoryLabel}</span>
          ) : (
            <span className="marketplace-product-grid-card__company">{transactionLabel}</span>
          )}
          {location ? (
            <span className="marketplace-product-grid-card__location">
              <FaMapMarkerAlt aria-hidden /> {location}
            </span>
          ) : null}
        </div>

        <div className="marketplace-product-grid-card__price-row">
          {priceLabel ? <p className="marketplace-product-grid-card__price">{priceLabel}</p> : null}
        </div>

        {specItems.length ? (
          <dl className="marketplace-product-grid-card__specs">
            {specItems.map((spec, index) => (
              <div
                key={spec.empty ? `empty-${index}` : `${spec.label}-${spec.value}`}
                className={`marketplace-product-grid-card__spec${
                  spec.empty ? " marketplace-product-grid-card__spec--empty" : ""
                }`}
                aria-hidden={spec.empty ? true : undefined}
              >
                {!spec.empty ? (
                  <>
                    <dt>{spec.label}</dt>
                    <dd>{spec.value}</dd>
                  </>
                ) : null}
              </div>
            ))}
          </dl>
        ) : null}
      </div>

      <div className="marketplace-product-grid-card__actions">
        <div className="marketplace-product-grid-card__actions-primary">
          <Link to={detailHref} className="marketplace-product-grid-card__btn marketplace-product-grid-card__btn--primary">
            View Listing
          </Link>
          <Link
            to={`${detailHref}&enquire=1`}
            className="marketplace-product-grid-card__btn marketplace-product-grid-card__btn--outline-dark"
          >
            Enquire Now
          </Link>
        </div>
        <div className="marketplace-product-grid-card__actions-secondary">
          <MarketplaceProductShareButton
            productId={item.id}
            title={item.title}
            sharePath={detailHref}
            imageUrl={getInfraListingShareImage(item)}
            companyName={item.categoryLabel || transactionLabel}
            description={item.description || `Infrastructure listing in ${location || "India"}`}
            className="marketplace-product-grid-card__share"
            triggerClassName="marketplace-product-grid-card__btn marketplace-product-grid-card__btn--ghost marketplace-product-share__trigger"
          />
        </div>
      </div>
    </article>
  );
}
